/**
 * The API's reason for a refusal when it is written for the user, else `null`.
 *
 * The API marks such an answer with `userFacing: true` on the ProblemDetails
 * (`UserFacingBadRequestException`), with a finished Danish sentence in `detail`. Its other errors are
 * English and technical, and sometimes repeat a payment gateway's own words ("Amount mismatch. Pay4It:
 * 250. ABOOK: 200"), so they are never shown as they are.
 *
 * The one definition of that contract for every app: the admin app's interceptor and the customer
 * app's error messages both read it through here.
 */
export function userFacingDetail(error: unknown): string | null {
  const problem = (error as { error?: { detail?: unknown; userFacing?: unknown } } | null)?.error;
  const detail = problem?.detail;
  return problem?.userFacing === true && typeof detail === 'string' && detail.trim()
    ? detail
    : null;
}
